import React from 'react';
import { useTranslator } from 'tradera/lang/translate';
import { InternationalIdentificationModal } from './international-identification-modal';

export const MessagingInternationalIdentificationModal = ({
    onCloseModal,
    onVerifyComplete
}) => {
    const { t } = useTranslator();

    return (
        <InternationalIdentificationModal
            onCloseModal={onCloseModal}
            onVerifyComplete={onVerifyComplete}
            purpose="Messaging"
            introText={t('international_identification_intro_text')}
            heading={t('international_identification_heading')}
        />
    );
};
